import { Images, LayoutDashboard } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { cn } from '@/lib/utils'

const tabs = [
  { to: '/workbench', icon: LayoutDashboard, labelKey: 'navigation.workbench' },
  { to: '/library', icon: Images, labelKey: 'navigation.product_library' },
]

export const BottomTabBar = ({ className }: { className?: string }) => {
  const { t } = useTranslation('common')

  return (
    <nav
      className={cn(
        'flex h-16 items-center justify-around border-t border-border bg-card pb-[env(safe-area-inset-bottom)]',
        className,
      )}
    >
      {tabs.map(({ to, icon: Icon, labelKey }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex min-w-14 flex-col items-center gap-1 px-3 py-2 text-xs',
              isActive ? 'text-primary' : 'text-muted-foreground',
            )
          }
        >
          <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} />
          <span>{t(labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  )
}
